export default "__VITE_ASSET__B9HZ4MVw__"